import { CustomerStatus } from '@trnsact/trnsact-shared-types';
import { MUIBaseEntity } from 'components/shared/MUITable';

export interface CustomerTableRow extends MUIBaseEntity {
  id: string;
  accountId: string;
  name: string;
  contactName: string;
  phone: string;
  type: string;
  lastContactDate: string;
  status: CustomerStatus;
  totalRevenueAmount?: number | null;
  activeDealsNumber?: number | null;
  opportunitiesNumber?: number | null;
}

export interface CreditAppTableRow extends MUIBaseEntity {
  id: string;
  vendorOpportunityId: string;
  createdDateTime: string;
  signedBy: string;
  salesRep: string;
  location: string;
  equipment: string;
  applyingFor: string;
}

export interface DocumentsTableRow extends MUIBaseEntity {
  id: string;
  documentId: string;
  vendorOpportunityId: string;
  source: string;
  docType: string;
  docDescription: string;
  createdBy: string;
  docName: string;
  createdDateTime: string;
  taskId: string;
  taskRegrading: string;
  customerAccountName: string;
}

export enum CustomerDetailsTabs {
  General = 'general',
  ActivityHub = 'activityHub',
  Documents = 'documents',
  Opportunities = 'opportunities',
  Revenue = 'revenue',
  CreditApps = 'creditApps',
  CreiditLine = 'creditLine',
}

export interface CustomerInfoCardConfiguration {
  title: string;
  icon: any;
  content: any;
}
